import { render, staticRenderFns } from "./NotSafeForWork2.vue?vue&type=template&id=64299a1c&scoped=true&"
import script from "./NotSafeForWork2.vue?vue&type=script&lang=js&"
export * from "./NotSafeForWork2.vue?vue&type=script&lang=js&"
import style0 from "./NotSafeForWork2.vue?vue&type=style&index=0&id=64299a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64299a1c",
  null
  
)

export default component.exports